// extracted by mini-css-extract-plugin
export default {"details":"details_lb9f","isBrowser":"isBrowser_bmU9","collapsibleContent":"collapsibleContent_i85q"};